import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { ProductFeatureCellComponent } from '@mkp/product/feature-product-shared';
import { BenefitFlagPipe, ProductPlatformCellComponent } from '@mkp/product/ui';
import {
  featureMapping,
  Product,
  ProductOfferingFeature,
  ProductOfferingFeatureCell,
} from '@mkp/shared/models';
import { AssetComponent } from '@mkp/shared/ui-asset';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'mkp-product-comparison-table-features',
  imports: [
    AssetComponent,
    BenefitFlagPipe,
    ProductPlatformCellComponent,
    ProductFeatureCellComponent,
    TranslateModule,
  ],
  templateUrl: './product-comparison-table-features.component.html',
  styleUrl: './product-comparison-table-features.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductComparisonTableFeaturesComponent implements OnChanges {
  @Input() products!: Product[];
  @Input() feature!: ProductOfferingFeature;

  featureMappings: ProductOfferingFeatureCell[] = [];
  translation: string | undefined;

  ngOnChanges() {
    if (this.products?.length && this.feature) {
      this.translation = featureMapping[this.feature].title;

      this.featureMappings = this.products.map((product) => this.getFeatureMapping(product));
    }
  }

  getFeatureMapping(product: Product): ProductOfferingFeatureCell {
    const productFeatureId = product.features.find(({ parent, id }) =>
      [id, parent].includes(this.feature.toString())
    )?.id as ProductOfferingFeature;

    const feature = featureMapping[productFeatureId ?? this.feature];

    return {
      id: feature.parent || this.feature,
      value: Boolean(productFeatureId),
      translation: feature.translation,
    } as ProductOfferingFeatureCell;
  }
}
